module.exports = __webpack_public_path__ + "static/img/workerdiscuss.86b3982.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/workerdiscuss.jpeg
// module id = I0KI
// module chunks = 73